import { render, staticRenderFns } from "./BoSidebar.vue?vue&type=template&id=b0c991a4&"
import script from "./BoSidebar.vue?vue&type=script&lang=js&"
export * from "./BoSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports